<template>
  <div class="mx-auto">
    <v-card flat class="pa-2">
      <v-card-text>
        <v-alert v-if="!isPreview" text color="blue" icon="mdi-information">
          <div class="black--text">
            <b>Petunjuk Pengisian</b>, jawaban semua pernyataan berikut yang dianggap paling mewakili diri Anda<br />
            <span class="caption">
              Berikut ini terdapat sejumlah pernyataan terkait pelaksanaan kegiatan pendampingan Program Sekolah
              Penggerak oleh Fasilitator. Jawablah semua pernyataan di bawah ini dengan memilih jawaban dengan klik pada
              bagian yang dianggap paling mewakili diri Anda. Setiap pernyataan, diberikan 4 pilihan jawaban. Pilihan
              jawabannya adalah:
            </span>
            <div>
              <table>
                <tr>
                  <td>Sangat Tidak Setuju</td>
                  <td> : </td>
                  <td>Bila Anda merasa sangat tidak setuju dengan pernyataan tersebut.</td>
                </tr>
                <tr>
                  <td>Tidak Setuju</td>
                  <td> : </td>
                  <td>Bila Anda merasa tidak setuju dengan pernyataan tersebut.</td>
                </tr>
                <tr>
                  <td>Setuju</td>
                  <td> : </td>
                  <td>Bila Anda merasa setuju dengan pernyataan tersebut.</td>
                </tr>
                <tr>
                  <td>Sangat Setuju</td>
                  <td> : </td>
                  <td>Bila Anda merasa sangat setuju dengan pernyataan tersebut.</td>
                </tr>
              </table>
            </div>
          </div>
        </v-alert>

        <template v-for="(sch, i) in instruments">
          <div :key="i" class="black--text">
            <div v-if="$getDeepObj(sch, 'title')" class="body-1 font-weight-medium my-2" v-html="sch.title" />
            <template v-if="sch.items">
              <v-row v-for="(ins, j) in sch.items" :key="j">
                <v-col cols="12" md="5" sm="12"> {{ j }}. {{ ins }} </v-col>
                <v-col cols="12" md="7" sm="12">
                  <div class="radio-outline">
                    <template v-for="(skor, s) in sch.skors">
                      <span class="mx-md-1" :key="s">
                        <input
                          type="radio"
                          :id="`${j}_${s}`"
                          v-model="form['nilai'][j]"
                          :value="`${s}`"
                          :disabled="isPreview"
                          checked
                        />
                        <label :for="`${j}_${s}`">{{ skor }}</label>
                      </span>
                    </template>
                  </div>
                </v-col>
                <v-col cols="12" md="12" sm="12">
                  <v-divider />
                </v-col>
              </v-row>
            </template>
            <template v-else-if="sch.children">
              <v-row>
                <template v-for="(child, idChild) in sch.children">
                  <v-col :key="idChild" cols="12" sm="12" :md="child.grid || 12">
                    <div class="pt-3 px-3">
                      <span v-html="child.label" />
                    </div>
                    <template v-for="(ins, i) in child.instrumen">
                      <div :key="i" v-if="ins.type === 'Checkbox'">
                        <v-checkbox
                          v-model="form[child.name][ins.name]"
                          :label="ins.label"
                          :value="ins.value"
                          :disabled="
                            ($getDeepObj(form, 'hambatan.8') && ins.name !== '8' && idChild === 0) ||
                              ($getDeepObj(form, 'dukungan.4') && ins.name !== '4' && idChild === 1)
                          "
                          :readonly="isPreview"
                          class="mx-2 my-1"
                          hide-details
                          @change="onChangeOpsi(child, ins.name)"
                        />
                      </div>
                    </template>
                    <div
                      class="mx-3"
                      v-show="
                        ($getDeepObj(form, 'hambatan.9') && idChild === 0) ||
                          ($getDeepObj(form, 'dukungan.5') && idChild === 1)
                      "
                    >
                      <v-text-field
                        v-model="form[child.name]['lainnya']"
                        placeholder="Tuliskan keterangan lainnya"
                        class="pt-0"
                        :readonly="isPreview"
                      ></v-text-field>
                    </div>
                  </v-col>
                </template>
              </v-row>
            </template>
            <template v-else>
              <base-form-generator :schema="sch.schema" v-model="form" class="pt-5 px-3" />
            </template>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
export default {
  props: {
    initValue: {
      type: Object,
      default: () => {},
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  components: { BaseFormGenerator },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    instruments() {
      return {
        pelaksanaan: {
          title: 'Pelaksanaan Kegiatan Pendampingan',
          items: {
            1: 'Tujuan kegiatan pendampingan jelas',
            2: 'Durasi pelaksanaan pendampingan sesuai dengan alokasi waktu yang telah ditetapkan ',
            3: 'Materi pendampingan bermanfaat bagi Anda',
            4: 'Materi dapat dipahami dengan mudah',
            5: 'Melaksanakan pendampingan sesuai jadwal yang telah disepakati',
            6: 'Menjalin komunikasi yang efektif selama proses persiapan hingga pelaksanaan pendampingan dengan Anda',
            7: 'Memahami substansi materi pendampingan dengan baik ',
            8: 'Mampu memfasilitasi forum dengan efektif*)',
            9: 'Mampu mendampingi Anda sesuai kebutuhan pengembangan diri',
            10: 'Mampu menciptakan suasana pendampingan yang nyaman dan menyenangkan',
            11: 'Mampu memotivasi Anda',
            12: 'Mampu mengelola kelompok dengan efektif*)',
          },
          skors: {
            sts: 'Sangat Tidak Setuju',
            ts: 'Tidak Setuju',
            s: 'Setuju',
            ss: 'Sangat Setuju',
          },
          keterangan: '*) Hanya untuk pendampingan secara kelompok',
        },
        pendukung: {
          title: 'Pendukung',
          items: {
            13: 'Jadwal kegiatan pendampingan sesuai dengan kesepakatan',
            14: 'Informasi kegiatan pendampingan diberikan minimal 3 (tiga) hari sebelum pelaksanaan kegiatan',
            15: 'Kemudahan mengakses SIM evaluasi dan pelaporan',
          },
          skors: {
            sts: 'Sangat Tidak Setuju',
            ts: 'Tidak Setuju',
            s: 'Setuju',
            ss: 'Sangat Setuju',
          },
        },
        saran: {
          title: '',
          schema: [
            {
              type: 'VTextarea',
              name: 'saran',
              label: 'Saran atau Masukan ',
              hint: 'wajib diisi',
              grid: { cols: 12, sm: 12, md: 12 },
              required: true,
              outlined: true,
              dense: true,
              singleLine: true,
              readonly: this.isPreview,
            },
          ],
        },
        dukungan: {
          title: 'Hambatan dan Dukungan',
          grid: 12,
          children: [
            {
              grid: 6,
              name: 'hambatan',
              label:
                'Jenis Hambatan apa yang paling sering ditemui peserta pelatihan selama proses IHT? <i>(jawaban boleh lebih dari satu)</i>',
              instrumen: [
                {
                  id: '1',
                  type: 'Checkbox',
                  name: '1',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Tidak memiliki cukup waktu untuk mengikuti IHT',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  id: '2',
                  type: 'Checkbox',
                  name: '2',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Tidak memiliki perangkat yang memadai',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  id: '3',
                  type: 'Checkbox',
                  name: '3',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Berada di wilayah yang memiliki jaringan internet kurang memadai ',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: '4',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Berada di wilayah yang memiliki jaringan listrik kurang memadai',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: '5',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Kesulitan dalam menggunakan platform belajar',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: '6',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Tidak mendapat dukungan lingkungan tempat saya bertugas untuk mengikuti proses IHT',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: '7',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Tidak mendapat dukungan dari keluarga untuk mengikuti proses IHT',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: '8',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Tidak ada',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: '9',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Lainnya',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1'],
                  grid: { cols: 12 },
                },
              ],
            },
            {
              grid: 6,
              name: 'dukungan',
              label:
                'Jenis Dukungan yang paling banyak diperlukan oleh peserta IHT agar proses IHT semakin baik? <i>(jawaban boleh lebih dari satu)</i>',
              instrumen: [
                {
                  type: 'Checkbox',
                  name: '1',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label:
                    'Penambahan durasi pelaksanaan IHT  untuk meningkatkan pengetahuan dan keterampilan sebagai guru/ pemimpin pembelajaran di dalam kelas',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: '2',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Pengenalan platform pembelajaran yang akan digunakan',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: '3',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Sarana dan prasarana pelaksanaan IHT',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: '4',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Tidak ada',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1', 'pb-0'],
                  grid: { cols: 12 },
                },
                {
                  type: 'Checkbox',
                  name: '5',
                  value: 1,
                  trueValue: 1,
                  falseValue: '',
                  label: 'Lainnya',
                  labelColor: 'black',
                  hint: 'wajib diisi',
                  hideDetails: true,
                  class: ['mt-0', 'pt-1'],
                  grid: { cols: 12 },
                },
              ],
            },
          ],
        },
      };
    },
  },
  methods: {
    reset() {
      this.$set(this, 'form', { nilai: {}, dukungan: {}, hambatan: {} });
    },

    onChangeOpsi(child, name) {
      if (this.form[child.name][name]) {
        if (['8', '4'].includes(name)) {
          for (const ins of child.instrumen || []) {
            if (ins.name !== name) {
              this.$set(this.form[child.name], ins.name, '');
            }
          }
        } else if (['8', '4'].includes(name)) {
          this.$set(this.form, `${child.name}`, { lainnya: null });
        }
      }
    },

    initForm(value) {
      if (!value) return;
      const keys = ['nilai', 'dukungan', 'hambatan', 'saran'];
      keys.forEach((key) => {
        if (['saran'].includes(key)) {
          this.$set(this.form, key, this.$getDeepObj(value, key) || '');
        } else {
          this.$set(this.form, key, this.$getDeepObj(value, key) || {});
        }
      });
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
